import React from 'react'
import { Icon } from 'react-icons-kit'
import { checkmark } from 'react-icons-kit/ionicons'

export default ({ onClick }) => (
  <button
    onClick={onClick}
    className="bg-primary hover:bg-primary-dark text-white font-semibold px-6 py-3 rounded-lg transition-colors duration-200 flex items-center gap-2 text-lg"
  >
    <Icon icon={checkmark} /> Checkout
  </button>
)
